var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47816 14.1249L3.47813 14.1249C2.11073 12.7577 1.35792 10.9385 1.35792 8.9991C1.35792 7.0597 2.11074 5.23955 3.47813 3.87243C4.84739 2.50343 6.66705 1.74993 8.60494 1.74993C10.541 1.74993 12.3616 2.50341 13.7308 3.8715C15.102 5.24326 15.8565 7.06348 15.8565 9.0009C15.8565 10.9383 15.102 12.7576 13.7318 14.1276C12.3634 15.4957 10.5438 16.2492 8.60585 16.2492C6.66799 16.2492 4.84744 15.4948 3.47816 14.1249ZM14.3683 3.23697C12.8301 1.69721 10.7827 0.85 8.60494 0.85C6.42803 0.85 4.38071 1.69815 2.84075 3.2378C-0.337011 6.41494 -0.337022 11.585 2.84072 14.7622C4.37981 16.3019 6.42807 17.15 8.60585 17.15C10.7827 17.15 12.83 16.3028 14.3691 14.764C15.9091 13.2243 16.7574 11.1774 16.7574 9.0018C16.7574 6.82268 15.9092 4.77575 14.3683 3.23697ZM12.5197 8.55003H9.05677V5.08603C9.05677 4.83741 8.85534 4.63606 8.60675 4.63606C8.35815 4.63606 8.15672 4.83741 8.15672 5.08603V8.55093H4.692C4.44399 8.55093 4.24198 8.7508 4.24198 9C4.24198 9.24862 4.44341 9.44997 4.692 9.44997H8.15492V12.9131C8.15492 13.1626 8.35725 13.3639 8.60494 13.3639C8.85383 13.3639 9.05497 13.1623 9.05497 12.9131V9.45087H12.5188C12.7674 9.45087 12.9688 9.24952 12.9688 9.0009C12.9688 8.75346 12.7695 8.55003 12.5197 8.55003Z",
    fill: "#270664",
    stroke: "#270664",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.858730df24c4089aa8608e1aee682aef.svg";
export { ForwardRef as ReactComponent };